import { useCreateAppointmentSchedulingLink } from '@/api/hooks/useCreateAppointmentSchedulingLink'
import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import { router } from 'expo-router'
import { Platform } from 'react-native'

const ScheduleAppointmentButton = () => {
	const { mutate: createSchedulingLink, isPending: isCreatingSchedulingLink } =
		useCreateAppointmentSchedulingLink()

	const onBookAppointmentClick = async () => {
		analytics.trackClick('scheduling-appointment-button')

		const schedulingWindow =
			Platform.OS === 'web' ? window.open(undefined, '_blank') : undefined
		createSchedulingLink(undefined, {
			onSuccess: ({ schedulingURL }) => {
				const urlWithUtms = `${schedulingURL}&utm_source=patient_app`

				if (Platform.OS === 'web') {
					schedulingWindow!.location = urlWithUtms
				} else {
					router.push({
						pathname: '/schedule-appointment',
						params: {
							scheduleUrl: urlWithUtms,
						},
					})
				}
			},
		})
	}

	return (
		<Button
			isLoading={isCreatingSchedulingLink}
			onPress={onBookAppointmentClick}
			withArrow
			className="max-w-64"
		>
			<ButtonText>Book an appointment</ButtonText>
		</Button>
	)
}

export { ScheduleAppointmentButton }
